<script lang="ts">
	import VerivoxOffersBanner from './internal/VerivoxOffersBanner.svelte';
	import type { VerivoxDismissSurface } from '../utils/verivoxDismissals';

	/** Verivox offers promo for the dashboard BannersWidget gallery (~180px). */
	export let dismissable = false;
	export let dismissSurface: VerivoxDismissSurface = 'energyDashboard';
	export let onDismiss: (() => void) | undefined;
</script>

<VerivoxOffersBanner layout="widget" {dismissable} {dismissSurface} {onDismiss} />
